import React from "react";

function DTOGoalDetailView() {
  return <></>;
}
export default DTOGoalDetailView;
